var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBonusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3 8L16.5 9.2L9.7 16L8.5 14.8L15.3 8ZM4.5 4H20.5C21.61 4 22.5 4.89 22.5 6V10C21.9696 10 21.4609 10.2107 21.0858 10.5858C20.7107 10.9609 20.5 11.4696 20.5 12C20.5 12.5304 20.7107 13.0391 21.0858 13.4142C21.4609 13.7893 21.9696 14 22.5 14V18C22.5 19.11 21.61 20 20.5 20H4.5C3.96957 20 3.46086 19.7893 3.08579 19.4142C2.71071 19.0391 2.5 18.5304 2.5 18V14C3.61 14 4.5 13.11 4.5 12C4.5 11.4696 4.28929 10.9609 3.91421 10.5858C3.53914 10.2107 3.03043 10 2.5 10V6C2.5 5.46957 2.71071 4.96086 3.08579 4.58579C3.46086 4.21071 3.96957 4 4.5 4ZM4.5 6V8.54C5.10768 8.8904 5.61236 9.39466 5.96325 10.0021C6.31415 10.6094 6.4989 11.2985 6.4989 12C6.4989 12.7015 6.31415 13.3906 5.96325 13.9979C5.61236 14.6053 5.10768 15.1096 4.5 15.46V18H20.5V15.46C19.8923 15.1096 19.3876 14.6053 19.0367 13.9979C18.6858 13.3906 18.5011 12.7015 18.5011 12C18.5011 11.2985 18.6858 10.6094 19.0367 10.0021C19.3876 9.39466 19.8923 8.8904 20.5 8.54V6H4.5ZM10 8C10.83 8 11.5 8.67 11.5 9.5C11.5 10.33 10.83 11 10 11C9.17 11 8.5 10.33 8.5 9.5C8.5 8.67 9.17 8 10 8ZM15 13C15.83 13 16.5 13.67 16.5 14.5C16.5 15.33 15.83 16 15 16C14.17 16 13.5 15.33 13.5 14.5C13.5 13.67 14.17 13 15 13Z",
    fill: "#C5C6C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonusIcon);
export default __webpack_public_path__ + "static/media/bonus_icon.1da18b0216a0194186bb86d647e31d1f.svg";
export { ForwardRef as ReactComponent };